import { useState } from "react";
import { TextEditorForm } from "./tekstEditor";
import { EventsForm } from "./scheduledEventsEditor";
import PhotoManager from "./photoManager";
import RocznikManager from "./RocznikManager";
import { AddNewsForm } from "./dodawanieAktualnosci";
import EventCreator from "./addEvent";
import { AdminKafelki } from "./adminTiles";
import { AdminInbox } from "./adminInbox";


export const AdminPage = () => {
    const [chosenPage, setChosenPage] = useState(0);
    const [menuOpen, setMenuOpen] = useState(false); // 🔁 Nowy stan dla menu

    const pagesSet = [
        <AddNewsForm />,
        <TextEditorForm />,
        <EventsForm />,
        <>
            <RocznikManager />
        </>,
        <PhotoManager />,
        <>
            <AdminKafelki type={"contacts"} />
            <AdminKafelki type={"socials"} />
        </>,
        <AdminInbox/>

    ];

    return (
        <>
            <div className="adminToggleButton" onClick={() => setMenuOpen(!menuOpen)}>
                ☰ Menu
            </div>

            <div className="adminPageMainbox">
                <div className={`adminLeft ${menuOpen ? "open" : ""}`}>
                    <div className="adminMenuPadding b">Admin panel</div>
                    <div className="adminMenuElement" onClick={() => { setChosenPage(0); setMenuOpen(false); }}>
                        Aktualności
                    </div>
                    <div className="adminMenuElement" onClick={() => { setChosenPage(1); setMenuOpen(false); }}>
                        Teksty na stronie
                    </div>
                    <div className="adminMenuElement" onClick={() => { setChosenPage(2); setMenuOpen(false); }}>
                        Wydarzenia nadchodzące
                    </div>
                   


                    <div className="adminMenuElement" onClick={() => { setChosenPage(4); setMenuOpen(false); }}>
                        Galeria zdjęć
                    </div>
                    <div className="adminMenuElement" onClick={() => { setChosenPage(5); setMenuOpen(false); }}>
                        Kafelki (strona kontakt)
                    </div>
                    <div className="adminMenuElement" onClick={() => { setChosenPage(6); setMenuOpen(false); }}>
                        Skrzynka odbiorcza
                    </div>
                    <div className="adminMenuPadding"></div>
                </div>

                <div className="adminRight">
                    {pagesSet[chosenPage]}
                </div>
            </div>
        </>
    );
};
